import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReach = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 61.5 61.51181",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Reach" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.52414,49.97741v3.99193S41.1575,59.83489,30.757,59.7049c-10.40812.13-14.78242-5.73556-14.78242-5.73556V49.97741c1.52949-2.76075,10.20928-5.27673,10.20928-5.27673V40.30341a12.41891,12.41891,0,0,1-2.28657-5.75847l-.5659-3.23489V28.6258a7.42564,7.42564,0,0,1,14.85127,0v2.68425l-.53533,3.24249a12.68478,12.68478,0,0,1-2.3248,5.75087v4.39727S44.01,47.21666,45.52414,49.97741Z",
			style: {
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.77666,41.9991a16.81249,16.81249,0,1,1,25.9551-.01021",
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.57988,45.9419a23.2561,23.2561,0,1,1,36.12719.26241",
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.98637,50.06953a29.5,29.5,0,1,1,45.542-.01791",
			style: {
				fill: "none",
				stroke: "#454545",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		})
	]
});
export default SvgReach;
